import React from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { Link, useLocation } from "react-router-dom";
import { formatDate } from "../master/Master";

const KitsDetailsTable = () => {
  const location = useLocation();
  // const studentId = location?.state?.id
  const queryParams = new URLSearchParams(location.search);
  const studentId = queryParams.get("id");
  const kitsData = [
    {
      id: 1,
      kitName: "hoodi",
      quantity: 1,
      remark: "1",
      date: "30-Jun-2025",
    },
  ];

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Header />
        <div className="layout-page">
          <Nav />
          <div className="content-wrapper container-fluid  flex-grow-1 ">
            <div className="container-xxl flex-grow-1 container-p-y ">
              <div className="card mb-4 p-5">
                <div className="d-flex gap-3 justify-content-end"></div>

                <div className="d-flex flex-wrap gap-3 ">
                  <Link
                    to={`/student/details?id=${studentId}`}
                    className="btn btn-sm btn-label-primary"
                  >
                    Student Profile
                  </Link>

                  <Link
                    to={`/student/course_fee?id=${studentId}`}
                    className="btn btn-sm btn-label-primary"
                  >
                    Course & Fee
                  </Link>
                  <Link
                    to={`/student/hostel?id=${studentId}`}
                    className="btn btn-sm btn-label-primary"
                  >
                    Student Hostel
                  </Link>

                  <Link
                    to={`/student/marks_report?id=${studentId}`}
                    className="btn btn-sm btn-label-primary"
                  >
                    Marks Report
                  </Link>
                  <Link
                    to={`/student/kit_report?id=${studentId}`}
                    className="btn btn-sm btn-primary"
                  >
                    Kit Report
                  </Link>
                  <Link
                    to={`/students`}
                    className="btn btn-sm btn-outline-primary ms-auto"
                  >
                    <i className="bi bi-arrow-left-circle me-1"></i> Back
                  </Link>
                </div>
              </div>

              <div className="card p-5">
                <div className="table-responsive">
                  <table className="table text-center table-bordered align-middle mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>Kit Name</th>
                        <th>Quantity</th>
                        <th>Remark</th>
                        <th>Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {kitsData.map((kit, index) => (
                        <tr key={kit.id}>
                          <td>{index + 1}</td>
                          <td className="fw-semibold">{kit.kitName}</td>
                          <td>{kit.quantity}</td>
                          <td>{kit.remark}</td>
                          <td className="fw-semibold">{formatDate(kit.date)}</td>
                          <td>
                            <button className="btn btn-sm bg-success bg-opacity-75 text-white">
                              <i className="bi bi-eye"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                      {kitsData.length === 0 && (
                        <tr>
                          <td colSpan="6" className="text-center text-muted">
                            No kit data found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KitsDetailsTable;
